import { Button, Checkbox, Chip, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { DataGrid } from "@mui/x-data-grid";
import { fDateTime } from "../../../utils/formatTime";
import MainCard from "../../../components/Maincard";
import EditIconcomp from "../../newComponent/iconsComp/EditIconcomp";
import CustomPopup from "../../../components/CustomPopup";
import EditMissedLeadsForm from "./EditMissedLeadsForm";
import EditMissedMetaLeads from "./EditMissedMetaLeads";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import VeiwIcon from "../../newComponent/iconsComp/VeiwIcon";
import ViewMissedMetaLead from "./ViewMissedMetaLead";
import DenyIcon from "../../newComponent/iconsComp/DenyIcon";
import ConfirmationPopup from "../../../components/ConfirmationPopup";
import { useGetTokenOrLogout } from "../../../utils/token";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import SelectedItemButton from "../../newComponent/NewButtonComp/SelectedItemButton";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function MissMetaLead({
  handelclose,
  handelopen,

  selectedid,
  setSelectedid,
  setMissedMetaOriginalLead,
  setMissMetaLead,
  missmetaLead,
  missmetaOriginalLead,
  handleUpdateStatus,
}) {
  const [selectedData, setSelectedData] = useState([]);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [openViewPopup, setOpenViewPoupup] = useState(false);
  const [cancelOpen, setCancelOpen] = useState(false);

  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 100,
  });

  const [prevPageSize, setPrevPageSize] = useState(pagination.pageSize);

  // Current Date
  const [visibleRowIds, setVisibleRowIds] = useState([]); // Store current page's row IDs
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // Upadate current page ids when pagination is chnages
  useEffect(() => {
    setPrevPageSize(pagination.pageSize);

    // new pagesize is less than prev page size then deselct all selected ids first
    if (pagination.pageSize !== prevPageSize) {
      setSelectedid([]);
      return;
    }

    // Update visible row IDs when pagination changes
    const currentPageRows = missmetaLead.slice(
      pagination.page * pagination.pageSize,
      (pagination.page + 1) * pagination.pageSize
    );
    const visibleIds = currentPageRows.map((row) => row.id);
    setVisibleRowIds(visibleIds);

    // If there are no visible rows, set SelectAllChecked to false
    if (visibleIds.length === 0) {
      setIsSelectAllChecked(false);
      setIsIndeterminate(false);
      return;
    }

    // Check if all visible rows are selected
    const allVisibleSelected = visibleIds.every((id) =>
      selectedid?.includes(id)
    );
    const someVisibleSelected = visibleIds.some((id) =>
      selectedid?.includes(id)
    );

    setIsSelectAllChecked(allVisibleSelected);
    setIsIndeterminate(someVisibleSelected && !allVisibleSelected);
  }, [pagination, missmetaLead, selectedid]);

  // HandleSelectAllCheckBox
  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setIsSelectAllChecked(checked);

    if (checked) {
      // Select all visible row IDs
      setSelectedid((prevSelectedIds) => [
        ...new Set([...prevSelectedIds, ...visibleRowIds]),
      ]);
    } else {
      // Deselect all visible row IDs
      setSelectedid((prevSelectedIds) =>
        prevSelectedIds.filter((id) => !visibleRowIds.includes(id))
      );
    }
  };

  // Individual CheckBox
  const handleCheckboxChange = (event, id) => {
    const checked = event.target.checked;

    setSelectedid((prevSelectedIds) => {
      if (checked) {
        const newSelected = [...prevSelectedIds, id];
        // Check if all visible rows are selected after this checkbox is checked
        const allVisibleSelected = visibleRowIds.every((rowId) =>
          newSelected.includes(rowId)
        );
        setIsSelectAllChecked(allVisibleSelected);
        setIsIndeterminate(!allVisibleSelected);

        return newSelected;
      } else {
        // Deselect the row ID
        const newSelected = prevSelectedIds.filter((rowId) => rowId !== id);
        setIsSelectAllChecked(false);
        setIsIndeterminate(
          visibleRowIds.some((rowId) => newSelected.includes(rowId))
        );

        return newSelected;
      }
    });
  };

  // Select All Row
  const handleSelectAllData = () => {
    if (missmetaLead.length === selectedid.length) {
      setSelectedid([]);
    } else {
      const allRowIds = missmetaLead.map((row) => row.id);
      setSelectedid(allRowIds);
    }
  };

  const columns = [
    {
      field: "selection",
      sortable: false,
      disableColumnMenu: true,

      renderHeader: (params) => (
        <Checkbox
          size="small"
          checked={isSelectAllChecked}
          indeterminate={isIndeterminate}
          onChange={handleSelectAllChange}
        />
      ),
      headerClassName: "header-cell",
      width: 70,
      renderCell: (params) => {
        const isChecked = selectedid?.includes(params.row?.id);
        return (
          <Checkbox
            size="small"
            checked={isChecked}
            onChange={(event) => handleCheckboxChange(event, params.row?.id)}
          />
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <VeiwIcon
              fontSize="0.9rem"
              onClick={() => handleOpenView(params.row)}
              tooltipTitle="View"
            />
            <EditIconcomp
              fontSize="0.9rem"
              onClick={() => handleEditOpen(params.row)}
              tooltipTitle="Edit"
            />
            <DenyIcon
              fontSize="0.9rem"
              tooltipTitle="Delete"
              onClick={() => handleCancelOpen(params.row)}
            />
          </div>
        );
      },
    },

    {
      field: "name",
      headerName: "Name",
      width: 150,
      valueGetter: (params) =>
        `${params.row?.first_name || ""} ${params.row?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.first_name} {params.row?.last_name}
        </div>
      ),
    },

    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,
      valueGetter: (params) =>
        ` ${params.row?.mobile_country_code} ${params.row?.mobile || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.mobile_country_code}
          {params.row?.mobile}
        </div>
      ),
    },
    {
      field: "email",
      headerName: "Email ID",
      width: 220,
    },
    {
      field: "enquired_service",
      headerName: "Enquired Service",
      width: 150,
      valueGetter: (params) => `${params.row?.service_id?.service_name || ""}`,
      renderCell: (params) => <div>{params.row.service_id?.service_name}</div>,
    },

    {
      field: "sub_service_id",
      headerName: "Sub Service",
      width: 150,
      valueGetter: (params) => `${params.row?.sub_service_id?.name || ""}`,
      renderCell: (params) => <div>{params.row.sub_service_id?.name}</div>,
    },
    {
      field: "branch_id",
      headerName: "STM Nearest Branch",
      width: 200,
      valueGetter: (params) =>
        `${params.row?.nearest_branch_id?.branch_name || ""}`,
      renderCell: (params) => (
        <div>{params.row.nearest_branch_id?.branch_name} </div>
      ),
    },
    {
      field: "permanent_assignee",
      headerName: "Permanent Assignee",
      width: 150,
      valueGetter: (params) =>
        `${params.row?.assign_to?.first_name || ""} ${
          params.row?.assign_to?.last_name || ""
        }`,
      renderCell: (params) => (
        <div>
          {params.row.assign_to?.first_name} {params.row.assign_to?.last_name}
        </div>
      ),
    },

    {
      field: "lead_source_type_id",
      headerName: "Lead Source",
      width: 150,
      valueGetter: (params) => `${params.row?.lead_source_type_id?.name || ""}`,
      renderCell: (params) => (
        <div>{params.row.lead_source_type_id?.name} </div>
      ),
    },
    {
      field: "sub_lead_source_type_name",
      headerName: "Sub Lead Source",
      width: 150,
      valueGetter: (params) =>
        `${params.row?.sub_lead_source_type_id?.source_type || ""}`,
      renderCell: (params) => (
        <div>{params.row?.sub_lead_source_type_id?.source_type} </div>
      ),
    },

    {
      field: "facebook_campaign_id",
      headerName: "Facebook Campaign",
      width: 250,
      valueGetter: (params) => `${params.row?.facebook_campaign_name || ""}`,
      renderCell: (params) => <div>{params.row?.facebook_campaign_name} </div>,
    },

    {
      field: "campaign_id",
      headerName: "Stm Campaign",
      width: 350,
      valueGetter: (params) =>
        `${params.row?.campaign_id?.campaign_name || ""}`,
      renderCell: (params) => (
        <div>{params.row?.campaign_id?.campaign_name} </div>
      ),
    },

    {
      field: "first_country",
      headerName: "First Country Of Interest",
      width: 150,
      valueGetter: (params) =>
        `${params.row?.target_country_id?.country_name || ""}`,
      renderCell: (params) => (
        <div>{params.row.target_country_id?.country_name} </div>
      ),
    },

    {
      field: "created_time",
      headerName: "Created Time",
      width: 150,
      valueGetter: (params) => `${params.row?.createdAt || ""}`,
      renderCell: (params) => <div>{fDateTime(params.row?.createdAt)} </div>,
    },
  ];



  const handleEditOpen = (data) => {
    setSelectedData(data);
    setOpenEditPopup(true);
    setSelectedid([data?.id]);
  };

  const handleEditClose = () => {
    setOpenEditPopup(false);
    setSelectedid([]);
  };

  const handleOpenView = (data) => {
    setSelectedData(data);
    setOpenViewPoupup(true);
    setSelectedid([data?.id]);
  };

  const handleCloseView = () => {
    setOpenViewPoupup(false);
    setSelectedid([]);
  };

  const handleCancelOpen = (data) => {
    setSelectedData(data);
    setCancelOpen(true);
    setSelectedid([data?.id]);
  };

  const handleCancelClose = () => {
    setCancelOpen(false);
    setSelectedid([]);
  };

  // search all column in datagrid
  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = missmetaOriginalLead.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data.first_name || ""}
              ${data.last_name || ""}`,

        `${data?.mobile_country_code || ""} ${data?.mobile || ""}`,
        `${data?.service_id?.service_name}`,
        `${data?.sub_service_id?.name}`,
        `${data?.nearest_branch_id?.branch_name}`,
        `${data?.assign_to?.first_name || ""} ${data?.assign_to?.last_name}`,
        `${data?.enquiry_id?.stage_id?.stage_name}`,
        `${data?.email || ""}`,
        `${data?.lead_source_type_id?.name || ""}`,
        `${data?.sub_lead_source_type_id?.source_type}`,
        `${data?.campaign_id?.campaign_name}`,
         `${data?.campaign_id?.facebook_campaign_name}`,
        
        `${fDateTime(data?.createdAt)}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setMissMetaLead(filteredData1); // Update the filtered data
  };

  
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                container
                gap={1}
                alignItems="center"
              >
                <Chip
                  label={
                    missmetaLead.length !== selectedid.length ||
                    missmetaLead.length === 0
                      ? "Select All"
                      : "Deselect All"
                  }
                  variant="outlined"
                  size="small"
                  onClick={() => handleSelectAllData()}
                />
                <SelectedItemButton value={selectedid.length} />
              </Grid>

              <Grid item xs={12} sm={12} md={6} textAlign="end">
                <SearchTextFieldComp onChange={handleSearchByName} />
              </Grid>

              <Grid item xs={12}>
                <DataGrid
                  rows={missmetaLead}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  pageSizeOptions={[25, 50, 100]}
                  pageSize={pagination.pageSize}
                  onPaginationModelChange={(model) => setPagination(model)}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      {/*Edit*/}
      <CustomPopup
        open={openEditPopup}
        onClose={handleEditClose}
        component={
          <EditMissedMetaLeads
            onClose={handleEditClose}
            selectedRowData={selectedData}
          />
        }
        title="Edit Missed Auto Assign Meta Lead"
        maxWidth="sm"
        showDivider={true}
      />

      {/*View*/}
      <CustomPopup
        open={openViewPopup}
        onClose={handleCloseView}
        component={
          <ViewMissedMetaLead
            onClose={handleCloseView}
            selectedRowData={selectedData}
          />
        }
        title="View Student Details"
        maxWidth="sm"
        showDivider={true}
      />

      <ConfirmationPopup
        open={cancelOpen}
        onClose={handleCancelClose}
        title="Confirmation"
        textBody="Are you sure you want to delete this lead ?"
        maxWidth="xs"
        showDivider={true}
        handleUpdateStatus={handleUpdateStatus}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
